<ng-container *ngIf="config?.theme && config?.theme === 1">
  <div class="d-flex justify-content-between" style="background-color: #f3f2f7">
    <div class="col-4 my-auto">
      <a (click)="redirect()">
        <img class="imagen" [src]="config?.logo" alt="logo-inmo" />
      </a>
    </div>

    <div class="col-4 my-auto">
      <button
        type="button"
        class="btn-buscardor btn btn-outline-secondary btn-block round text-secondary"
        rippleEffect
        (click)="abreModal(modalBasic)"
      >
        <i data-feather="search" class="mr-0 mr-sm-1"></i>
        <span class="d-none d-sm-inline-block">Buscar</span>
      </button>
    </div>

    <div class="col-4 my-auto d-flex justify-content-end">
      <div class="p-1 my-auto">
        <button
          type="button"
          class="btn btn-sm"
          [style]
          rippleEffect
          [style]="
            'border-color:' +
            config?.primaryColor +
            ' !important;background-color:' +
            config?.primaryColor +
            ' !important;color:' +
            config.secondaryColor +
            ' !important;'
          "
          (click)="nosotros()"
        >
          <i data-feather="users" class="mr-0 mr-sm-1"></i>
          <span class="d-none d-sm-inline-block">Nosotros</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="config?.theme && config?.theme === 2">
  <div class="d-flex justify-content-between" [style]="'background-color:' + config?.primaryColor + '50;'">
    <div class="col-4 my-auto">
      <a (click)="redirect()" *ngIf="domainHome !== '/'">
        <img class="imagen" [src]="config?.logo" alt="logo-inmo" />
      </a>
    </div>

    <div class="col-4 my-auto">
      <button
        type="button"
        class="btn btn-block round"
        [style]="
          'border:2px solid ' +
          config?.primaryColor +
          '; !important; background-color:white !important;color:' +
          config?.primaryColor +
          ' !important;'
        "
        rippleEffect
        (click)="abreModal(modalBasic)"
      >
        <i data-feather="search" class="mr-0 mr-sm-1"></i>
        <span class="d-none d-sm-inline-block" style="font-weight: bolder">Buscar</span>
      </button>
    </div>

    <div class="col-4 my-auto d-flex justify-content-end">
      <div class="p-1 my-auto">
        <button
          type="button"
          class="btn btn-sm round"
          [style]
          rippleEffect
          [style]="
            'border:2px solid ' +
            config?.primaryColor +
            '; !important; background-color:white !important;color:' +
            config?.primaryColor +
            ' !important;'
          "
          (click)="nosotros()"
        >
          <i data-feather="users" class="mr-0 mr-sm-1"></i>
          <span class="d-none d-sm-inline-block" style="font-weight: bolder">Nosotros</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="config?.theme && config?.theme === 3">
  <div class="d-flex justify-content-between" [style]="'background-color:' + config?.primaryColor + '50;'">
    <div class="col-4 my-auto">
      <a (click)="redirect()">
        <img class="imagen" [src]="config?.logo" alt="logo-inmo" />
      </a>
    </div>

    <div class="col-4 my-auto">
      <button
        type="button"
        class="btn btn-block round"
        [style]="
          'border:2px solid ' +
          config?.primaryColor +
          '; !important; background-color:white !important;color:' +
          config?.primaryColor +
          ' !important;'
        "
        rippleEffect
        (click)="abreModal(modalBasic)"
      >
        <i data-feather="search" class="mr-0 mr-sm-1"></i>
        <span class="d-none d-sm-inline-block" style="font-weight: bolder">Buscar</span>
      </button>
    </div>

    <div class="col-4 my-auto d-flex justify-content-end">
      <div class="p-1 my-auto">
        <button
          type="button"
          class="btn btn-sm round"
          [style]
          rippleEffect
          [style]="
            'border:2px solid ' +
            config?.primaryColor +
            '; !important; background-color:white !important;color:' +
            config?.primaryColor +
            ' !important;'
          "
          (click)="nosotros()"
        >
          <i data-feather="users" class="mr-0 mr-sm-1"></i>
          <span class="d-none d-sm-inline-block" style="font-weight: bolder">Nosotros</span>
        </button>
      </div>
    </div>
  </div>

  <div [style]="'heigh: auto; widt: 100%; background-color: ' + config?.primaryColor">
    <div class="row" tyle="border: solid green 1px">
      <div class="col-12 d-none d-sm-none d-md-block mt-1 mb-1" [style]="'color:' + config.secondaryColor">
        <span class="ml-2 mr-1" [data-feather]="'map-pin'" size="20"></span>
        <!-- <span style="margin-top: 5px;">{{config.street}} {{config.noExt}}, {{config.suburb}}, {{config.state.name}}</span> -->
        <a
          href="{{
            'https://www.google.com/maps?q=' +
              config.street +
              ' ' +
              config.noExt +
              ', ' +
              config.suburb +
              ', ' +
              config.state.name
          }}"
          [style]="'color:' + config.secondaryColor"
          >{{ config.street }} {{ config.noExt }}, {{ config.suburb }}, {{ config.state.name }},
          {{ config.province?.name }}</a
        >
        <!-- <a href="{{ 'https://www.google.com/maps?q=' + config.office.latitude +','+ config.office.longitude }}" [style]="'color:'+config.secondaryColor">{{config.street}} {{config.noExt}}, {{config.suburb}}, {{config.state.name}}</a> -->
      </div>
    </div>
    <hr style="margin: 0px" />
    <div class="row" tyle="border: solid red 1px"></div>
    <div class="row" tyle="border: solid blue 1px">
      <div class="col-6 d-none d-sm-none d-md-block" [style]="'color:' + config.secondaryColor">
        <div class="d-md-flex align-items-center h-100">
          <span class="ml-2 mr-1" [data-feather]="'phone'" size="20"></span>
          <span class="mr-1" style="margin-top: 5px"
            >{{ config.phone1 | slice : 0 : 3 }}-{{ config.phone1 | slice : 3 : 6 }}-{{
              config.phone1 | slice : 6 : 10
            }}</span
          >
          <a
            href="tel:+1234567890"
            style="
              background-color: white !important;
              padding-top: 2px;
              padding-left: 9px;
              padding-right: 9px;
              border-radius: 6px;
              border: solid black 1px;
            "
          >
            <span style="font-weight: bold">Llamar</span>
          </a>

          <span class="ml-2 mr-1" [data-feather]="'mail'" size="20"> </span>
          <a
            href="{{
              'mailto:' +
                config.emailRealEstate +
                '?subject=Solicitud de información&body=Hola,%20me%20gustaría%20saber%20más%20sobre%20su%20inmobiliaria.'
            }}"
            [style]="'color:' + config.secondaryColor"
            >{{ config.emailRealEstate }}</a
          >
          <!-- <span style="margin-top: 5px;">{{config.emailRealEstate}}</span> -->
        </div>
      </div>
      <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
        <button
          type="button"
          class="btn btn-icon btn-icon rounded-circle mr-1"
          rippleEffect
          (click)="redirectSN(1)"
          *ngIf="config.instagramUrl"
        >
          <img src="../../../../../assets/icon/instagram.png" alt="" height="20px" />
        </button>
        <button
          type="button"
          class="btn btn-icon btn-icon rounded-circle mr-1"
          rippleEffect
          (click)="redirectSN(2)"
          *ngIf="config.tikTokUrl"
        >
          <img src="../../../../../assets/icon/tik-tok.png" alt="" height="20px" />
        </button>
        <button
          type="button"
          class="btn btn-icon btn-icon rounded-circle mr-1"
          rippleEffect
          (click)="redirectSN(3)"
          *ngIf="config?.fbUrl"
        >
          <img src="../../../../../assets/icon/facebook.png" alt="" height="20px" />
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #modalBasic let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Búsqueda por filtros</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="1" ngbAutofocus>
    <span *ngIf="obligatorios" class="text-danger">Estos campos son obligatorios</span>
    <span *ngIf="precioMal" class="text-danger">El precio mayor debe ser más grande que el mínimo</span>
    <div class="row">
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <label for="basicInput">Tipo de operación <small class="red">*</small></label>
          <div class="input-group input-group-merge round">
            <ng-select
              [multiple]="true"
              [closeOnSelect]="false"
              class="custom"
              [items]="operationTypes"
              bindLabel="name"
              bindValue="name"
              [(ngModel)]="parametrosBusqueda.types"
              name="operationType"
              id="operationType"
              #operationType="ngModel"
              required
            >
            </ng-select>
          </div>
          <div *ngIf="operationType.invalid && (operationType.dirty || operationType.touched)" class="alert">
            <small class="text-danger" *ngIf="operationType.errors?.['required']">
              El tipo de operación es obligatorio
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-md-8 col-12">
        <div class="form-group">
          <label for="basicInput">Tipo de propiedad <small class="red">*</small></label>
          <div class="input-group input-group-merge round">
            <ng-select
              [multiple]="true"
              [closeOnSelect]="false"
              class="custom"
              [items]="propertyTypes"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="parametrosBusqueda.propertyTypes"
              name="propertyType"
              id="propertyType"
              #propertyType="ngModel"
              required
            >
            </ng-select>
          </div>

          <div *ngIf="propertyType.invalid && (propertyType.dirty || propertyType.touched)" class="alert">
            <small class="text-danger" *ngIf="propertyType.errors?.['required']">
              El tipo de propiedad es obligatorio
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-12">
        <div class="form-group">
          <label for="basicInput">Precio mínimo <small class="red">*</small></label>
          <div
            class="input-group input-group-merge round"
            [ngClass]="minPrice.invalid && (minPrice.dirty || minPrice.touched) ? 'is-invalid' : ''"
          >
            <div class="input-group-prepend">
              <span class="input-group-text round"><span [data-feather]="'dollar-sign'"></span></span>
            </div>
            <input
              maxlength="13"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              #commaInput1
              (ngModelChange)="onQtrInputChange($event, 1)"
              (focus)="onFocusCommaInput(1)"
              (blur)="onBlurCommaInput()"
              [ngModel]="parametrosBusqueda.range.lowerText | currencyCommasHundredsLanding"
              type="text"
              class="form-control round"
              required
              [ngClass]="minPrice.invalid && (minPrice.dirty || minPrice.touched) ? 'is-invalid' : ''"
              name="minPrice"
              id="minPrice"
              #minPrice="ngModel"
            />
          </div>
          <div *ngIf="minPrice.invalid && (minPrice.dirty || minPrice.touched)" class="alert">
            <small class="text-danger" *ngIf="minPrice.errors?.['required']"> El precio mínimo es obligatorio </small>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-12">
        <div class="form-group">
          <label for="basicInput">Precio máximo <small class="red">*</small></label>
          <div
            class="input-group input-group-merge round"
            [ngClass]="maxPrie.invalid && (maxPrie.dirty || maxPrie.touched) ? 'is-invalid' : ''"
          >
            <div class="input-group-prepend">
              <span class="input-group-text round"><span [data-feather]="'dollar-sign'"></span></span>
            </div>
            <input
              maxlength="13"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              #commaInput2
              (ngModelChange)="onQtrInputChange($event, 2)"
              (focus)="onFocusCommaInput(2)"
              (blur)="onBlurCommaInput()"
              [ngModel]="parametrosBusqueda.range.upperText | currencyCommasHundredsLanding"
              type="text"
              class="form-control round"
              required
              [ngClass]="maxPrie.invalid && (maxPrie.dirty || maxPrie.touched) ? 'is-invalid' : ''"
              name="maxPrie"
              id="maxPrie"
              #maxPrie="ngModel"
            />
          </div>

          <div *ngIf="maxPrie.invalid && (maxPrie.dirty || maxPrie.touched)" class="alert">
            <small class="text-danger" *ngIf="maxPrie.errors?.['required']"> El precio máximo es obligatorio </small>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="basicInput">Colonia</label>
          <i style="font-size: 12px"> (Si deseas hacer una búsqueda general deja vacío el campo)</i>
          <div class="input-group input-group-merge round">
            <ng-select
              [multiple]="true"
              [closeOnSelect]="false"
              class="custom"
              [items]="suburbsBasic"
              bindLabel="fullName"
              bindValue="id"
              [loading]="provincesLoading"
              [(ngModel)]="parametrosBusqueda.suburbs"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <h4>
      Búsqueda avanzada
      <button
        type="button"
        class="btn btn-icon rounded-circle"
        [style]="'background-color:transparent;color:' + config?.primaryColor + ';'"
        rippleEffect
        (click)="mostrarBusquedaAvanzada()"
      >
        <i
          class="feather text-primary"
          [ngClass]="{ 'icon-chevron-down': !showBusquedaAvanzada, 'icon-chevron-up': showBusquedaAvanzada }"
        ></i>
      </button>
    </h4>

    <div *ngIf="showBusquedaAvanzada">
      <div class="row amenities-style">
        <!-- <div class="col-xl-4 col-md-6 col-sm-6  custom-control custom-checkbox ">
                    <div class="form-group">
                        <input type="checkbox" class="custom-control-input" id="exclusive" [(ngModel)]="exclusive" />
                        <label class="custom-control-label text-break text-truncate" for="exclusive">Solo propiedades
                            exclusivas
                        </label>
                    </div>
                </div> -->
      </div>
      <div class="row">
        <div class="col-12 custom-control custom-checkbox ml-1">
          <div class="form-group">
            <input
              type="checkbox"
              class="custom-control-input"
              [(ngModel)]="parametrosBusqueda.amenities[8].cant"
              [id]="parametrosBusqueda.amenities[8].id"
              value="1"
            />
            <label class="custom-control-label text-break text-truncate" [for]="parametrosBusqueda.amenities[8].id">
              Amueblado / Renta
            </label>
          </div>
        </div>
        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Recámaras</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="bedrooms"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[0].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Baños</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="bathrooms"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[1].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Cochera</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="garageOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[2].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Niveles</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="nivelesOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[5].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Mts<sup>2</sup> de terreno</label>
            <div class="input-group input-group-merge round">
              <div class="input-group-prepend">
                <span class="input-group-text round">
                  <img src="assets/icon/IconGray/area.png" height="16" width="16" />
                </span>
              </div>
              <input
                type="text"
                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\.*)\./g, '$1');"
                class="form-control round"
                [(ngModel)]="parametrosBusqueda.amenities[3].cant"
              />
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Mts<sup>2</sup> de construcción</label>
            <div class="input-group input-group-merge round">
              <div class="input-group-prepend">
                <span class="input-group-text round"
                  ><img src="assets/icon/IconGray/area.png" height="16" width="16"
                /></span>
              </div>
              <input
                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\.*)\./g, '$1');"
                type="text"
                class="form-control round"
                [(ngModel)]="parametrosBusqueda.amenities[4].cant"
              />
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Jardín</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="gardenOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[6].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Terraza</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="terrazaOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[7].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Años de antigüedad</label>
            <div class="input-group input-group-merge round">
              <ng-select class="custom" [items]="yearsAnt" bindLabel="name" bindValue="value" [(ngModel)]="years.cant">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row amenities-style">
        <div class="col-xl-4 col-md-6 col-sm-6 custom-control custom-checkbox" *ngFor="let am of amenities_ops">
          <div class="form-group">
            <img [src]="'assets/icon/IconGray/' + am.icon" height="20" width="20" />&nbsp;
            <input
              type="checkbox"
              class="custom-control-input"
              [style]="'background:' + config?.primaryColor + ' !important;'"
              [id]="am.id"
              [(ngModel)]="am.switch"
            />
            <label class="custom-control-label text-break text-truncate" [for]="am.id">{{ am.name }} </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="mr-auto">
      {{ state?.name
      }}<ng-container *ngIf="provinces?.length > 0"
        ><span *ngFor="let p of provinces">, {{ p.name }}</span></ng-container
      >
      <div
        class="bold curs"
        [style]="'color:' + config?.primaryColor + ' !important;'"
        (click)="abreModal2(modalUbication)"
      >
        Cambiar localización
      </div>
    </div>
    <!-- <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Cross click')">Cerrar</button> -->
    <button
      type="button"
      class="btn round"
      (click)="busqueda()"
      rippleEffect
      [style]="
        'border-color:' +
        config?.primaryColor +
        ' !important;background-color:' +
        config?.primaryColor +
        ' !important;color:' +
        config.secondaryColor +
        ' !important;'
      "
    >
      Buscar
    </button>
  </div>
</ng-template>

<ng-template #modalUbication let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel2">Cambiar ubicación</h4>
    <!-- <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button> -->
  </div>

  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="row">
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <label for="basicInput">Estado</label>
          <div class="input-group input-group-merge round">
            <ng-select
              class="custom"
              [items]="statesBasic"
              bindLabel="name"
              bindValue="id"
              [loading]="stateLoading"
              [(ngModel)]="state.id"
              (change)="getProvinces($event)"
            >
            </ng-select>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <label for="basicInput">Ciudad</label>
          <div class="input-group input-group-merge round">
            <ng-select
              class="custom"
              [items]="provincesBasic"
              bindLabel="name"
              [loading]="provincesLoading"
              [(ngModel)]="provinces"
              [multiple]="true"
              (change)="getSuburbs($event)"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <i style="color: red" *ngIf="!bandProvince"> Favor de llenar los dos campos </i>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn round"
      [style]="
        'border-color:' +
        config?.primaryColor +
        ' !important;background-color:' +
        config?.primaryColor +
        ' !important;color:' +
        config.secondaryColor +
        ' !important;'
      "
      (click)="checkSelect()"
      rippleEffect
    >
      Guardar
    </button>
  </div>
</ng-template>
